import React, { Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './utils/errorBoundary';
import CustomCursor from './component/CustomCursor';

// Ensure React is properly initialized
if (typeof window !== 'undefined') {
  window.React = React;
}

// Optimized loading component with reduced bundle size
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-primary-50 to-white">
    <div className="relative">
      <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary-600"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <div className="animate-pulse text-primary-600 text-sm">Loading...</div>
      </div>
    </div>
  </div>
);

const App = ({ model }) => {
  const [components, setComponents] = useState({
    HomePagePresenter: null,
    ProjectPagePresenter: null,
    SpecializationPagePresenter: null,
    AboutMePagePresenter: null,
    ProfessionalProjectsPagePresenter: null
  });

  useEffect(() => {
    // Load components in parallel
    Promise.all([
      import('./presenter/homePagePresenter'),
      import('./presenter/projectPagePresenter'),
      import('./presenter/specializationPagePresenter'),
      import('./presenter/aboutMePagePresenter'),
      import('./presenter/professionalProjectsPagePresenter')
    ]).then(([
      HomePagePresenter,
      ProjectPagePresenter,
      SpecializationPagePresenter,
      AboutMePagePresenter,
      ProfessionalProjectsPagePresenter
    ]) => {
      setComponents({
        HomePagePresenter: HomePagePresenter.default,
        ProjectPagePresenter: ProjectPagePresenter.default,
        SpecializationPagePresenter: SpecializationPagePresenter.default,
        AboutMePagePresenter: AboutMePagePresenter.default,
        ProfessionalProjectsPagePresenter: ProfessionalProjectsPagePresenter.default
      });
    }).catch(error => {
      console.error('Failed to load components:', error);
    });
  }, []);

  if (!components.HomePagePresenter) {
    return <LoadingSpinner />;
  }

  return (
    <Router basename={import.meta.env.BASE_URL || '/'}>
      <ErrorBoundary>
        <CustomCursor />
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<components.HomePagePresenter model={model} />} />
            <Route path="/about-me" element={<components.AboutMePagePresenter model={model} />} />
            <Route path="/projects" element={<components.ProjectPagePresenter model={model} />} />
            <Route path="/professional-projects" element={<components.ProfessionalProjectsPagePresenter model={model} />} />
            <Route path="/specialization" element={<components.SpecializationPagePresenter model={model} />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </Router>
  );
};

export default React.memo(App);
